// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GC4v","label":"styles_label__20pyU"};